export default {
  toast: {
    color: 'success',
    text: 'Success',
    show: false
  },
  loggedIn: false,
  token: ''
}
